export default __webpack_public_path__ + "static/cloud-native_02-ecf456378273404c13af39fe1bd207db.png";